<template>
  <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
    <v-card-title class="primary white--text" style="height: 52px; padding: 0px;">
      <v-btn icon @click="$emit('justCloseDialogConfirm')"><v-icon class="white--text">close</v-icon></v-btn>
      <div class="title tf_title_dialog" v-html="titleDialogConfirm"></div>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <div>{{ buildEnhancementInstruction() }}</div>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <v-select
            v-model="selectActionPrompt"
            :items="computedActionUrl"
            item-text="text"
            item-value="id"
            :label="$t('promptselect')"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            :value="getCurrentPromptValue()"
            :label="$t('promptcurrent')"
            readonly
            auto-grow
            rows="8"
            outline
          ></v-textarea>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            v-model="enhancementSystemPrompt"
            :label="$t('promptadditional')"
            auto-grow
            rows="8"
            outline
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeDialogConfirm()">{{ $t('close') }}</v-btn>
      <v-btn
        color="primary"
        :loading="loadingEnhance"
        :disabled="loadingEnhance || !selectedPromptField()"
        @click="enhancePromptWithAI"
      >
        {{ $t('promptameliore') }}
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-model="showDialogComparePrompt"
      persistent
      scrollable
      max-width="90%"
    >
      <v-card>
        <v-card-title class="primary white--text compare-title">
          <v-btn icon dark @click="closeCompareDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <span class="title compare-title-text">{{ $t('promptcompare') }}</span>
        </v-card-title>
        <v-card-text class="compare-body">
          <v-layout row wrap class="mb-2">
            <v-flex xs12 md6 class="pr-3 compare-top-cell">
              <div class="compare-top-title">
                <strong>{{ $t('Section') }}</strong> {{ selectedPromptLabel() }}
              </div>
            </v-flex>
            <v-flex xs12 md6 class="pl-3 compare-top-cell compare-top-cell-right">
              <div class="compare-top-title">
                {{ $t('promptameliored') }} ({{ enhancedVariants.length }})
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6 class="pr-3 compare-col compare-col-panel">
              <h3 class="mb-2 compare-label">{{ $t('promptactual') }}</h3>
              <v-textarea
                :value="getCurrentPromptValue()"
                readonly
                auto-grow
                rows="12"
                class="compare-main-textarea"
                outline
              ></v-textarea>
            </v-flex>
            <v-flex xs12 md6 class="pl-3 compare-col compare-col-panel">
              <v-card
                v-if="enhancedVariants.length"
                flat
                class="mb-3 pa-2 variant-selected"
              >
                <div class="d-flex justify-space-between align-center mb-1">
                  <strong>Version {{ selectedVariantIndex + 1 }}</strong>
                  <span>{{ selectedVariantIndex + 1 }} / {{ enhancedVariants.length }}</span>
                </div>
                <v-textarea
                  :value="selectedEnhancedPrompt()"
                  @input="setSelectedVariantContent($event)"
                  auto-grow
                  rows="6"
                  class="compare-variant-textarea"
                  outline
                ></v-textarea>
                <div class="d-flex justify-end">
                  <v-btn
                    small
                    flat
                    color="primary"
                    :disabled="selectedVariantIndex <= 0"
                    @click="showPreviousVariant"
                  >
                    Précédente
                  </v-btn>
                  <v-btn
                    small
                    color="primary"
                    :disabled="selectedVariantIndex >= (enhancedVariants.length - 1)"
                    @click="showNextVariant"
                  >
                    Variante
                  </v-btn>
                </div>
                <v-divider class="my-3"></v-divider>
                <div class="iteration-title">Itérations sur cette version</div>
                <div ref="iterationThread" class="iteration-thread">
                  <div
                    v-for="(msg, idx) in iterationMessages"
                    :key="`iter-msg-${idx}`"
                    class="iteration-message"
                    :class="msg.role === 'user' ? 'iteration-message--user' : 'iteration-message--assistant'"
                  >
                    <strong>{{ msg.role === 'user' ? 'Vous' : 'IA' }} :</strong>
                    <span>{{ msg.content }}</span>
                  </div>
                </div>
                <v-textarea
                  v-model="iterationInput"
                  label="Instruction supplémentaire"
                  placeholder="Ex: rends le plus concis, ajoute des contraintes sur le ton..."
                  auto-grow
                  rows="3"
                  outline
                  class="mt-2"
                  @keydown.enter.exact.prevent="iterateEnhancedPrompt"
                ></v-textarea>
                <div class="d-flex justify-end">
                  <v-btn
                    small
                    color="primary"
                    :loading="loadingIterate"
                    :disabled="loadingIterate || !iterationInput.trim().length || !selectedEnhancedPrompt().length"
                    @click="iterateEnhancedPrompt"
                  >
                    Envoyer
                  </v-btn>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="closeCompareDialog">{{ $t('close') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="#001B39"
            dark
            :disabled="!selectedEnhancedPrompt().length || !selectedPromptField()"
            @click="openConfirmApplyDialog"
          >
            {{ $t('promptapply') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showDialogConfirmApply"
      persistent
      max-width="560"
    >
      <v-card>
        <v-card-title class="headline">{{ $t('promptconfirm') }}</v-card-title>
        <v-card-text>
          {{ $t('promptvalid1') }}<strong>{{ selectedPromptLabel() }}</strong>{{ $t('promptvalid2') }}
          <br>
          {{ $t('promptcontinue') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showDialogConfirmApply = false">{{ $t('Cancel') }}</v-btn>
          <v-btn color="#001B39" dark @click="confirmApplyEnhancedPrompt">{{ $t('confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: {
    showDialogConfirmation: {
      type: Boolean,
      default: false
    },
    titleDialogConfirm: {
      type: String,
      default: 'Améliorer le prompt avec l\'I.A.'
    },
    contentDialogConfirm: {
      type: String,
      default: ''
    },
    contentDialogRes: {
      type: String,
      default: ''
    },
    startLoading: {
      type: Number,
      default: 0
    },
    endLoading: {
      type: Number,
      default: 0
    },
    loadingRes: {
      type: Boolean,
      default: false
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    preselectedSection: {
      type: String,
      default: 'personality'
    },
    currentPromptData: {
      type: Object,
      default: () => ({})
    },
    sectionOptions: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      selectActionPrompt: 'personality',
      enhancementSystemPrompt: '',
      enhancementPromptBySection: {},
      enhancementPromptManualBySection: {},
      syncingEnhancementPrompt: false,
      loadingEnhance: false,
      showDialogComparePrompt: false,
      showDialogConfirmApply: false,
      enhancedPrompt: '',
      enhancedVariants: [],
      selectedVariantIndex: 0,
      loadingIterate: false,
      iterationInput: '',
      iterationMessages: []
    }
  },
  computed: {
    computedActionUrl () {
      if (Array.isArray(this.sectionOptions) && this.sectionOptions.length) {
        return this.sectionOptions
      }
      return [
        {text: this.$t('AIPersonnality'), id: 'personality'},
        {text: this.$t('AIEnviron'), id: 'environment'},
        {text: this.$t('AIObjective'), id: 'objectif'},
        {text: this.$t('AICommunication'), id: 'communication'},
        {text: this.$t('AIQuestion'), id: 'questions'},
        {text: this.$t('AIRules'), id: 'rules'},
        {text: this.$t('AITools'), id: 'tools'},
        {text: this.$t('AICustom'), id: 'custom'}
      ]
    }
  },
  watch: {
    selectActionPrompt (val, oldVal) {
      if (val !== oldVal) {
        this.syncEnhancementPromptForSection(val)
      }
    },
    preselectedSection (val) {
      if (typeof val === 'string' && val.length) {
        this.selectActionPrompt = val
        this.$nextTick(() => {
          this.syncEnhancementPromptForSection(this.selectActionPrompt)
        })
      }
    },
    currentPromptData: {
      deep: true,
      handler () {
        this.$nextTick(() => {
          this.syncEnhancementPromptForSection(this.selectActionPrompt)
        })
      }
    },
    enhancementSystemPrompt (val) {
      if (this.syncingEnhancementPrompt) return
      const field = this.selectedPromptField()
      if (!field) return

      this.$set(this.enhancementPromptBySection, field, val)

      const autoValue = this.getAutoEnhancementInstructionForField(field)
      const textValue = (val === undefined || val === null) ? '' : String(val)
      const hasManualValue = textValue.trim().length > 0 && textValue !== autoValue
      this.$set(this.enhancementPromptManualBySection, field, hasManualValue)
    },
    showDialogConfirmation (val) {
      if (val) {
        if (typeof this.preselectedSection === 'string' && this.preselectedSection.length) {
          this.selectActionPrompt = this.preselectedSection
        }
        this.$nextTick(() => {
          this.syncEnhancementPromptForSection(this.selectActionPrompt)
        })
      } else {
        this.resetTransientState()
      }
    },
    iterationMessages: {
      deep: true,
      handler () {
        this.scrollIterationToBottom()
      }
    }
  },
  created () {
    if (typeof this.preselectedSection === 'string' && this.preselectedSection.length) {
      this.selectActionPrompt = this.preselectedSection
    }
    this.syncEnhancementPromptForSection(this.selectActionPrompt)
  },
  methods: {
    defaultEnhancementSystemPrompt () {
      return this.buildEnhancementInstruction()
    },
    getSectionLabelByField (field) {
      const item = this.computedActionUrl.find(option => option.id === field)
      return item ? item.text : field
    },
    getCurrentPromptValueByField (field) {
      if (!field || !this.currentPromptData) return ''
      return this.currentPromptData[field] || ''
    },
    getAutoEnhancementInstructionForField (field) {
      const currentValue = this.getCurrentPromptValueByField(field)
      const hasCurrentValue = currentValue.toString().trim().length > 0
      const action = hasCurrentValue ? 'Améliore' : 'Créer'
      return action + ' la section ' + this.getSectionLabelByField(field) + ' de ce prompt.'
    },
    setEnhancementPromptForSection (field, value, isManual) {
      this.syncingEnhancementPrompt = true
      this.enhancementSystemPrompt = value
      this.syncingEnhancementPrompt = false
      this.$set(this.enhancementPromptBySection, field, value)
      this.$set(this.enhancementPromptManualBySection, field, !!isManual)
    },
    syncEnhancementPromptForSection (field) {
      if (!field) return
      const hasManualValue = this.enhancementPromptManualBySection[field] === true
      const savedValue = this.enhancementPromptBySection[field]

      if (hasManualValue && typeof savedValue === 'string' && savedValue.trim().length > 0) {
        this.setEnhancementPromptForSection(field, savedValue, true)
        return
      }

      const autoValue = this.getAutoEnhancementInstructionForField(field)
      this.setEnhancementPromptForSection(field, autoValue, false)
    },
    buildEnhancementInstruction () {
      const hasCurrentValue = this.getCurrentPromptValue().toString().trim().length > 0
      const action = hasCurrentValue ? 'Améliore' : 'Créer'
      return action + ' la section ' + this.selectedPromptLabel() + ' de ce prompt.'
    },
    resetTransientState () {
      this.enhancementSystemPrompt = this.defaultEnhancementSystemPrompt()
      this.enhancementPromptBySection = {}
      this.enhancementPromptManualBySection = {}
      this.syncingEnhancementPrompt = false
      this.loadingEnhance = false
      this.showDialogComparePrompt = false
      this.showDialogConfirmApply = false
      this.enhancedPrompt = ''
      this.enhancedVariants = []
      this.selectedVariantIndex = 0
      this.loadingIterate = false
      this.iterationInput = ''
      this.iterationMessages = []
    },
    closeDialogConfirm () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialogConfirm')
      } else {
        this.$emit('justCloseDialogConfirm')
      }
    },
    selectedPromptField () {
      if (typeof this.selectActionPrompt === 'string' && this.selectActionPrompt.length) {
        return this.selectActionPrompt
      }
      return ''
    },
    selectedPromptLabel () {
      const field = this.selectedPromptField()
      if (!field) return ''
      const item = this.computedActionUrl.find(option => option.id === field)
      return item ? item.text : field
    },
    getCurrentPromptValue () {
      const field = this.selectedPromptField()
      if (!field || !this.currentPromptData) return ''
      return this.currentPromptData[field] || ''
    },
    getOtherPromptSectionsContext (field) {
      const targetField = field || this.selectedPromptField()
      const keys = this.computedActionUrl.map(item => item.id)
      const context = {}
      keys.forEach(key => {
        if (key === targetField) return
        const value = this.currentPromptData && Object.prototype.hasOwnProperty.call(this.currentPromptData, key)
          ? this.currentPromptData[key]
          : ''
        context[key] = (value === undefined || value === null) ? '' : String(value)
      })
      return context
    },
    async enhancePromptWithAI () {
      const field = this.selectedPromptField()
      if (!field) return

      const currentValue = this.getCurrentPromptValue()
      const promptContext = this.getOtherPromptSectionsContext(field)
      const dataToPost = new window.FormData()
      dataToPost.append('section', field)
      dataToPost.append('current_prompt', currentValue)
      dataToPost.append('prompt_context', JSON.stringify(promptContext))
      dataToPost.append('user_instruction', '')
      dataToPost.append('enhance_system_prompt', this.enhancementSystemPrompt)
      dataToPost.append('variants_count', '3')

      this.loadingEnhance = true
      this.enhancedPrompt = ''
      this.enhancedVariants = []
      this.selectedVariantIndex = 0

      try {
        const response = await this.axios.post('post/enhance_openai_prompt.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        if (response && response.data && Array.isArray(response.data.variants)) {
          this.enhancedVariants = response.data.variants
            .map(v => (v && typeof v.content === 'string') ? v.content.trim() : '')
            .filter(v => v.length)
        } else {
          const enhanced = typeof response.data === 'string' ? response.data : ''
          this.enhancedVariants = enhanced.trim().length ? [enhanced.trim()] : []
        }
        this.enhancedPrompt = this.enhancedVariants.length ? this.enhancedVariants[0] : ''
        this.initIterationThreadFromSelectedVariant()
        this.showDialogComparePrompt = true
      } catch (_) {
        this.enhancedPrompt = ''
        this.enhancedVariants = []
        this.iterationMessages = []
      } finally {
        this.loadingEnhance = false
      }
    },
    selectedEnhancedPrompt () {
      if (!this.enhancedVariants.length) return ''
      if (this.selectedVariantIndex < 0 || this.selectedVariantIndex >= this.enhancedVariants.length) {
        return this.enhancedVariants[0]
      }
      return this.enhancedVariants[this.selectedVariantIndex]
    },
    showNextVariant () {
      if (!this.enhancedVariants.length) return
      if (this.selectedVariantIndex < this.enhancedVariants.length - 1) {
        this.selectedVariantIndex += 1
        this.initIterationThreadFromSelectedVariant()
      }
    },
    showPreviousVariant () {
      if (!this.enhancedVariants.length) return
      if (this.selectedVariantIndex > 0) {
        this.selectedVariantIndex -= 1
        this.initIterationThreadFromSelectedVariant()
      }
    },
    initIterationThreadFromSelectedVariant () {
      const base = this.selectedEnhancedPrompt()
      this.iterationInput = ''
      this.iterationMessages = base.length
        ? [{role: 'assistant', content: base}]
        : []
      this.scrollIterationToBottom()
    },
    setSelectedVariantContent (value) {
      if (!this.enhancedVariants.length) return
      if (this.selectedVariantIndex < 0 || this.selectedVariantIndex >= this.enhancedVariants.length) return
      this.$set(this.enhancedVariants, this.selectedVariantIndex, value)
      this.enhancedPrompt = this.enhancedVariants[0] || ''
    },
    async iterateEnhancedPrompt () {
      const field = this.selectedPromptField()
      const basePrompt = this.selectedEnhancedPrompt()
      const userInstruction = this.iterationInput.trim()
      if (!field || !basePrompt.length || !userInstruction.length) return

      const promptContext = this.getOtherPromptSectionsContext(field)
      const dataToPost = new window.FormData()
      dataToPost.append('section', field)
      dataToPost.append('current_prompt', this.getCurrentPromptValue())
      dataToPost.append('prompt_context', JSON.stringify(promptContext))
      dataToPost.append('user_instruction', userInstruction)
      dataToPost.append('enhance_system_prompt', this.enhancementSystemPrompt)
      dataToPost.append('base_prompt', basePrompt)
      dataToPost.append('conversation_history', JSON.stringify(this.iterationMessages || []))

      this.loadingIterate = true
      this.iterationMessages.push({role: 'user', content: userInstruction})
      this.iterationInput = ''

      try {
        const response = await this.axios.post('post/enhance_openai_prompt_chat.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        const content = response && response.data && typeof response.data.content === 'string'
          ? response.data.content.trim()
          : ''
        if (!content.length) {
          this.iterationMessages.push({role: 'assistant', content: 'Aucune proposition reçue. Essaie de reformuler ta demande.'})
          return
        }
        this.setSelectedVariantContent(content)
        this.iterationMessages.push({role: 'assistant', content: content})
      } catch (_) {
        this.iterationMessages.push({role: 'assistant', content: 'Erreur lors de l’itération. Merci de réessayer.'})
      } finally {
        this.loadingIterate = false
      }
    },
    closeCompareDialog () {
      this.showDialogComparePrompt = false
      this.showDialogConfirmApply = false
      this.iterationInput = ''
      this.iterationMessages = []
    },
    scrollIterationToBottom () {
      this.$nextTick(() => {
        const el = this.$refs.iterationThread
        if (!el) return
        el.scrollTop = el.scrollHeight
      })
    },
    openConfirmApplyDialog () {
      if (!this.selectedEnhancedPrompt().length) return
      this.showDialogConfirmApply = true
    },
    confirmApplyEnhancedPrompt () {
      const field = this.selectedPromptField()
      const promptToApply = this.selectedEnhancedPrompt()
      if (!field || !promptToApply.length) return

      this.$emit('applyEnhancedPromptSection', field, promptToApply)
      this.showDialogConfirmApply = false
      this.closeCompareDialog()
      this.closeDialogConfirm()
    }
  }
}
</script>

<style scoped>
.tf_title_dialog {
  text-overflow: ellipsis;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
}
.compare-col {
  margin-bottom: 12px;
}
.compare-col-panel {
  background: transparent !important;
  padding: 10px !important;
}
.compare-body {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.compare-body .layout {
  margin-left: 0;
  margin-right: 0;
}
.compare-body .flex {
  padding-left: 0;
  padding-right: 0;
}
.compare-label {
  margin-left: 0;
}
.compare-title {
  position: relative;
  align-items: center;
  justify-content: flex-start;
}
.compare-title-text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: calc(100% - 120px);
  text-align: center;
  pointer-events: none;
  line-height: 1.2;
}
.compare-body /deep/ .v-textarea textarea {
  font-size: 14px !important;
  line-height: 1.75 !important;
}
.compare-main-textarea /deep/ .v-input__slot,
.compare-variant-textarea /deep/ .v-input__slot {
  background: #ffffff !important;
  border: 1px solid #E0E0E0 !important;
}
.compare-main-textarea /deep/ fieldset,
.compare-variant-textarea /deep/ fieldset {
  border-color: #E0E0E0 !important;
}
.compare-top-cell {
  display: flex;
  align-items: center;
}
.compare-top-cell-right {
  justify-content: flex-end;
}
.compare-top-title {
  font-size: 15px;
  font-weight: 600;
}
.variant-selected {
  border: 1px solid #E0E0E0;
  background: transparent !important;
}
.iteration-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
}
.iteration-thread {
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #d7e3f3;
  border-radius: 6px;
  background: #fff;
  padding: 8px;
}
.iteration-message {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 6px;
  padding: 6px 8px;
  border-radius: 6px;
}
.iteration-message--assistant {
  background: #f2f7ff;
  border: 1px solid #d8e8ff;
}
.iteration-message--user {
  background: #f8f8f8;
  border: 1px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogEnhancePrompt.vue